import { useMemo } from "react";
import { CUSTOM_IMAGES_CONFIG } from "../utils/customImagesConfig";

const useCustomImagesConfig = (account, designatedDescriptionResponse) => {

    const matchingConfig = useMemo(() => {
        return CUSTOM_IMAGES_CONFIG.find((item) => {
            const groupCodeMatch = item.groupCodes.includes(account?.groupCode)
            const makeMatch =
                item.make ? item.make === designatedDescriptionResponse?.make?.toUpperCase() : true;

            return groupCodeMatch && makeMatch;
        });
    }, [account?.groupCode, designatedDescriptionResponse?.make]);

    const clientPhotosSettings = useMemo(() => {
        if (matchingConfig) {
            const { captionedPhoto, additionalPhotos } = matchingConfig;
            const captionedPhotoDescription = captionedPhoto?.description || null;
            const captionedPhotoItems = captionedPhoto?.items || [];
            const additionalPhotosDescription = additionalPhotos || [];

            return {
                captionedPhotoDescription,
                captionedPhotoItems,
                additionalPhotosDescription,
            };
        }
        return null;
    }, [matchingConfig]);

    return { clientPhotosSettings };
};

export default useCustomImagesConfig;